export const WARNING_DAYS = 30;

// "2026-08-18T00:00:00" -> "2026-08-18" (l'orario non serve)
export const toDateOnly = (value) => {
  if (typeof value !== "string" || !value) {
    return "";
  }
  return value.split("T")[0];
};

// "2026-08-18" -> "2026-08-18T00:00:00" (formato atteso dal BE)
export const toApiDate = (dateOnly) => {
  if (!dateOnly) {
    return null;
  }
  return toDateOnly(dateOnly) + "T00:00:00";
};

// "2026-08-18T00:00:00" -> Date locale a mezzanotte (null se non valida)
const toLocalDate = (value) => {
  var parts = toDateOnly(value).split("-");
  if (parts.length !== 3) {
    return null;
  }
  var year = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var day = parseInt(parts[2], 10);
  if (isNaN(year) || isNaN(month) || isNaN(day)) {
    return null;
  }
  var date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
};

// "2026-08-18T00:00:00" -> "18/08/2026" ("" se non valorizzata/non valida)
export const toDisplayDate = (value) => {
  var date = toLocalDate(value);
  if (date === null) {
    return "";
  }
  return (
    date.getDate().toString().padStart(2, "0") +
    "/" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    date.getFullYear().toString()
  );
};

// Come toDisplayDate ma con "-" per la card, come le altre info del portale
export const formatExpiration = (value) => {
  var display = toDisplayDate(value);
  return display === "" ? "-" : display;
};

// "18/08/2026" -> "2026-08-18" ("" se incompleta o non valida)
export const fromDisplayDate = (display) => {
  if (typeof display !== "string") {
    return "";
  }
  var parts = display.split("/");
  if (parts.length !== 3) {
    return "";
  }
  if (parts[0].length !== 2 || parts[1].length !== 2 || parts[2].length !== 4) {
    return "";
  }
  var iso = parts[2] + "-" + parts[1] + "-" + parts[0];
  return toLocalDate(iso) === null ? "" : iso;
};

// Digitazione libera -> "dd/mm/yyyy": tiene solo le cifre e inserisce le barre
export const maskDisplayDate = (raw) => {
  if (typeof raw !== "string") {
    return "";
  }
  var digits = raw.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) {
    return digits;
  }
  if (digits.length <= 4) {
    return digits.slice(0, 2) + "/" + digits.slice(2);
  }
  return digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4);
};

// -> { status: "unset" | "valid" | "warning" | "expired", days: number | null }
export const secretKeyStatus = (expiration) => {
  var date = toLocalDate(expiration);
  if (date === null) {
    return { status: "unset", days: null };
  }

  var now = new Date();
  var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var days = Math.round((date.getTime() - today.getTime()) / 86400000);

  if (days < 0) {
    return { status: "expired", days: days };
  }
  if (days <= WARNING_DAYS) {
    return { status: "warning", days: days };
  }
  return { status: "valid", days: days };
};
